import { Link } from "gatsby"
import React, { ReactElement } from "react"
import { SearchFilterType } from "../../types"
import * as styles from "./mobile-search-header.module.scss"
import { SearchFilterChip, SearchInputBar } from "."

const logoPath = "/QT-net.webp"

interface Props {
  searchFilters: (keyof typeof SearchFilterType)[]
  onSelectFilert: (type: keyof typeof SearchFilterType) => void
  onDeselectFilert: (type: keyof typeof SearchFilterType) => void
}

export const MobileSearchHeader = (props: Props): ReactElement => {
  // MARK: - Components

  const searchFilterChip = (
    type: keyof typeof SearchFilterType
  ): ReactElement => (
    <SearchFilterChip
      type={type}
      isSelected={props.searchFilters.includes(type)}
      onSelect={props.onSelectFilert}
      onDeselect={props.onDeselectFilert}
    />
  )

  return (
    <header className={styles.header}>
      <div className={styles.upperRow}>
        <Link to="/" className={styles.logo}>
          <img src={logoPath} alt="logo" width={48} height={20} />
        </Link>
        <div className={styles.searchInput}>
          <SearchInputBar />
        </div>
      </div>
      <div className={styles.lowerRow}>
        {searchFilterChip("AVAILABLE")}
        {searchFilterChip("QT_NET_RESEVABLE")}
        {searchFilterChip("QT_NET_POINT")}
        {searchFilterChip("QT_NET_SMART_PAY")}
        {searchFilterChip("WHEELCHAIR")}
      </div>
    </header>
  )
}
